import * as React from 'react';
import { ServiceContext } from '@services/ServiceContext';
import { Service } from '@services/types';

export const useServiceResolver = (): Service => {
    const service = React.useContext(ServiceContext);
    if (!service) {
        throw new Error('Service is not registered yet');
    }

    return service;
};
